module.exports = __webpack_public_path__ + "img/police_logo.5ce479de.svg";